import { useEffect, useState } from 'react';
import { metaSocialAPI } from '../lib/api';

export const useInboxAccess = (user) => {
  const isCeo = user?.role === 'ceo';
  const team = ['manager', 'member'].includes(user?.role);
  const [allowed, setAllowed] = useState(isCeo ? true : null);
  useEffect(() => {
    if (isCeo) { setAllowed(true); return; }
    if (!team) { setAllowed(false); return; }
    metaSocialAPI.myAccess().then((r) => setAllowed(!!r.allowed)).catch(() => setAllowed(false));
  }, [user?.id, isCeo, team]);
  return allowed;
};
